import { provideHttpClient, withInterceptors } from '@angular/common/http';
import {
	EnvironmentProviders,
	inject,
	Provider,
	provideAppInitializer,
} from '@angular/core';
import { authHttpInterceptorFn } from '@auth0/auth0-angular';
import { authInterceptor } from 'app/core/auth/auth.interceptor';
import { supportContextInterceptor } from 'app/core/auth/support-context.interceptor';
import { AuthService } from 'app/core/auth/auth.service';

export const provideAuth = (): Array<Provider | EnvironmentProviders> => {
	return [
		provideHttpClient(
			withInterceptors([
				authHttpInterceptorFn,
				authInterceptor,
				supportContextInterceptor,
			])
		),
		provideAppInitializer(() => {
			const auth = inject(AuthService);
			auth.initialize();
		}),
	];
};
